import { R as a, m as s, a as r, b as o, f as t, c as e, d as l, e as m, g as i, h as f, i as p, j as E, k as n, l as c, t as u, n as d, o as h, p as k, q as _, r as x, s as O, u as b, v as g, w as v, x as A, y as R, z as j, A as y, B as D, C as G } from "./Result.bs-d9de06b5.mjs";

const Ok = a => ({
  TAG: 0,
  _0: a
});

const Error = a => ({
  TAG: 1,
  _0: a
});

var N = {
  __proto__: null,
  Ok,
  Error,
  ResultError: a,
  mapException: s,
  makeOk: r,
  makeError: o,
  fromNullable: t,
  fromFalsy: e,
  fromPredicate: l,
  fromExecution: m,
  fromPromise: i,
  map: f,
  mapWithDefault: p,
  flatMap: E,
  getExn: n,
  getWithDefault: c,
  toUndefined: u,
  toNullable: d,
  toOption: h,
  match: k,
  isError: _,
  isOk: x,
  tap: O,
  tapError: b,
  handleError: g,
  mapError: v,
  catchError: A,
  recover: R,
  flip: j,
  filter: y,
  fold: D,
  all: G
};

export { Error as E, Ok as O, N as i };
